"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isTaskTime(object) {
    return checkTaskTime(object).fulfilled;
}
exports.isTaskTime = isTaskTime;
function checkTaskTime(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("id"), Check_1.hasString("taskId"), Check_1.hasNumber("startTime").integer(), Check_1.hasNumber("endTime").integer(), Check_1.hasString("userId").optional()).withOptions(options).explain();
}
exports.checkTaskTime = checkTaskTime;
//# sourceMappingURL=TaskTime.js.map